<template>
  <div class="video-container">
    <div id="container" ref="container" :class="['player-area-inner-trailer', {'active': isPlaying }]">
    <!--        <div class="player" id="player">-->
    <!--          <div class="player-bg">-->
    <!--            <span class="thum-bg" :style="{backgroundImage: `url(${backgroundImage})`}"></span>-->
    <!--          </div>-->
    <!--        </div>-->
    </div>
  </div>
</template>
<script>

import _ from 'lodash'
import { TRAILER_ATTR_BY_PLAYER_TYPE, PLAYER_TYPE } from '@/common/resources/player.const'
import { mapGetters } from 'vuex'
import { PLAYER_OPTIONS, PLAYER_PACKAGE_TYPE, playerDelegate, PlayerType } from '@/common/utils/scalable.player'
import { PlayerInterface } from '@/common/utils/player.interface'

export default {
  name: 'TrailerPlayer',
  props: {
    contentInfo: {
      type: Object
    },
    currentSection: {
      type: String
    }
  },
  components: {},
  data () {
    return {
      isPlaying: false
    }
  },
  methods: {
    playerInit: async function () {
      if (!PlayerInterface.isCreatedPlayerInstance()) {
        return false
      }
      PlayerInterface.unload()
      await PlayerInterface.load(this.contentType, this.contentId, { isAutoPlay: true })
      this.isPlaying = true
    },
  },
  computed: {
    contentType () {
      let _contentType = this.currentSection
      switch (this.currentSection) {
        case 'vod':
          _contentType = this.contentInfo.type === 'onair' ? PLAYER_TYPE.ONAIRVOD : PLAYER_TYPE.VOD
          break
        case 'baseball':
          _contentType = 'baseball'
          break
      }
      return _contentType
    },
    contentId () {
      return _.get(this.contentInfo, TRAILER_ATTR_BY_PLAYER_TYPE[this.currentSection].id, null)
    },
    backgroundImage () {
      return `https://${this.contentImage}`
    },
  },
  created () {
    // this.actionButtonSetting()
  },
  mounted () {
    let options = {}
    options[PLAYER_OPTIONS.IS_SEPARATE_UI] = false
    playerDelegate(this, this.$refs.container, PlayerType.TRAILER, PLAYER_PACKAGE_TYPE.SET_PC, options)
  },
  beforeDestroy () {
    PlayerInterface.destructor()
  },
  watch: {
    contentInfo () {
      // 플레이어 재진입
      this.playerInit()
    }
  }
}
</script>
<style scoped>
.player-area-inner-trailer{
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
}
</style>
